import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-enter",
  "use": "icon-form-enter-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-form-enter\">\r\n<path d=\"M100,0C75,0,51.4,8.9,32.5,26.1c-2.5,2.5-2.5,7.5,0,11.1c2.5,3.9,7.5,3.9,11.4,0c15-13.6,35-21.1,56.1-21.1\r\n\tc46.4,0,83.9,37.5,83.9,83.9s-37.5,83.9-83.9,83.9c-21.4,0-41.1-7.5-56.1-21.4c-2.5-3.6-8.6-3.6-11.4,0c-3.6,2.5-3.6,8.9,0,11.4\r\n\tC51.4,191.1,75,200,100,200c55,0,100-45,100-100S155,0,100,0 M96.4,126.1c-3.9,2.5-3.9,7.5,0,11.4c2.5,3.6,7.5,3.6,11.1,0l31.4-31.4\r\n\tc1.4-1.1,2.5-3.6,2.5-6.4v-1.4c0-2.5-1.1-5-2.5-6.4l-31.4-31.4c-2.5-3.6-7.5-3.6-11.1,0c-3.9,2.5-3.9,7.5,0,11.4l18.9,18.6H8.9\r\n\tc-5,0-8.9,3.6-8.9,8.9c0,3.6,3.9,7.5,8.9,7.5h106.4L96.4,126.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/form/form-enter.svg
// module id = s8iQ
// module chunks = 13